<div class="page-container">
    <mat-sidenav-container>
        <div id="account-page">
            <div id="page-header">
                <h1>Organizations</h1>
                <!-- TODO(backend): POST /appcloud/accounts is not exposed to the admin portal yet -->
                <button mat-raised-button type="button" class="r1-btn-black" [disabled]="true">
                    + Add Organization
                </button>
            </div>

            <div id="dashboard">
                <r1-accounts-kpi
                    [count]="store.kpiCount()"
                    [option]="store.kpiOption()"
                    (optionChange)="store.setKpiOption($event)" />
                <r1-account-creation-chart
                    [series]="store.chartSeries()"
                    [days]="store.chartDays()"
                    (daysChange)="store.setChartDays($event)" />
            </div>

            <mat-divider id="top-line" />

            <div id="accounts-table">
                <r1-accounts-table
                    [accounts]="store.items()"
                    [totalElements]="store.totalElements()"
                    [pageIndex]="store.pageIndex()"
                    [pageSize]="store.pageSize()"
                    [sortField]="store.search().sortField"
                    [sortOrder]="store.search().sortOrder"
                    [selectedId]="store.selectedId()"
                    (filterChange)="store.setFilter($event)"
                    (pageChange)="store.setPage($event.pageIndex, $event.pageSize)"
                    (sortChange)="store.setSort($event.active, $event.direction)"
                    (viewAccount)="store.view($event)"
                    (editAccount)="store.edit($event)"
                    (deleteAccount)="confirmDelete($event)" />
            </div>
        </div>

        @if (store.sidenavOpen()) {
            <mat-sidenav [opened]="true" mode="side" position="end" (closedStart)="store.closeSidenav()">
                @let account = store.selectedAccount();
                @if (account) {
                    <div class="sidenav-actions">
                        <button mat-raised-button type="button" (click)="store.toggleEditing()">
                            {{ store.editing() ? 'Cancel' : 'Edit' }}
                        </button>
                        <button mat-icon-button type="button" aria-label="Close" (click)="store.closeSidenav()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    @if (store.editing()) {
                        <r1-edit-account [account]="account" (patchAccountValue)="accountPatched($event)" />
                    } @else {
                        <r1-view-account [account]="account" />
                    }
                }
            </mat-sidenav>
        }
    </mat-sidenav-container>
</div>
